// Inline SVG sprite for the four card suits. One <symbol> per suit, referenced
// from each card via <use href="#suit-X"/>. Using SVG instead of Unicode
// glyphs ensures the suits render identically on every device (the system
// font's ♠ in particular varies wildly between Androids/iOS/desktop).

const SPRITE = `
<svg xmlns="http://www.w3.org/2000/svg" id="suit-defs" style="position:absolute; width:0; height:0; overflow:hidden;" aria-hidden="true">
  <defs>
    <symbol id="suit-S" viewBox="0 0 100 100">
      <g fill="currentColor" transform="scale(1.6667)">
        <g transform="rotate(225,30,30)">
          <rect width="30" height="30" x="20" y="20"/>
          <circle cx="20" cy="35" r="15"/>
          <circle cx="35" cy="20" r="15"/>
        </g>
        <path d="M30,30 Q30,50 20,60 H40 Q30,50 30,30"/>
      </g>
    </symbol>
    <symbol id="suit-H" viewBox="0 0 600 600">
      <g fill="currentColor" transform="rotate(45,300,300)">
        <rect x="150" y="150" height="350" width="350"/>
        <circle cx="150" cy="325" r="175"/>
        <circle cx="325" cy="150" r="175"/>
      </g>
    </symbol>
    <symbol id="suit-D" viewBox="0 0 100 100">
      <rect fill="currentColor" x="17" y="17" width="66" height="66" transform="rotate(45,50,50)"/>
    </symbol>
    <symbol id="suit-C" viewBox="0 0 100 100">
      <g fill="currentColor" transform="scale(1.6667)">
        <circle cx="18" cy="35" r="14"/>
        <circle cx="30" cy="15" r="14"/>
        <circle cx="42" cy="35" r="14"/>
        <path d="M30,30 Q30,50 20,60 H40 Q30,50 30,30"/>
      </g>
    </symbol>
  </defs>
</svg>
`;

export function injectSuitSprite(): void {
  if (document.getElementById("suit-defs")) return;
  const wrapper = document.createElement("div");
  wrapper.innerHTML = SPRITE.trim();
  const svg = wrapper.firstElementChild;
  if (svg) document.body.appendChild(svg);
}
